/* Common Imports */

import React, { useState, useEffect } from "react";
import loadable from "@loadable/component";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import SectionOne from "../../components/page-sections/classes/SectionOne";
import AboutClasses from "../../components/page-sections/classes/AboutClasses";
import LocationMap from "../../components/page-sections/classes/LocationMap";
import AppConfig from "../../AppConfig";

const SectionThree = loadable(() =>
  import("../../components/page-sections/classes/SectionThree")
);
const SectionFive = loadable(() =>
  import("../../components/page-sections/index/SectionFive")
);

const Classes = () => {
  const [classess, setClassess] = useState([]);

  useEffect(() => {
    fetch(AppConfig.apiUrlPrefix + "classes")
      .then((r) => r.json())
      .then((d) => {
        setClassess(d.classes_head);
      })
      .catch((e) => console.error(e));
  }, []);
  return (
    <React.Fragment>
      <Layout>
        {classess.map((classHead, key) => {
          return (
            <SectionOne
              key={key}
              heading={
                classHead.heading
                  ? classHead.heading
                  : "Classes to pick the best cloud stratergy"
              }
              subHeading={
                classHead.subHeading
                  ? classHead.subHeading
                  : "Our cloud experts help you devise your winning recipe for cloud strategy success."
              }
              btnLabel={classHead.btnLabel ? classHead.btnLabel : "Know More"}
              btnHref={classHead.btnHref ? classHead.btnHref : "#"}
              illustration={
                classHead.illustration
                  ? classHead.illustration
                  : "/images/illustrations/classes/Classes.svg"
              }
            />
          );
        })}
        <AboutClasses />
        <LocationMap />
        <SectionThree />
        <SectionFive source="classes-page" />
      </Layout>
    </React.Fragment>
  );
};

export default Classes;
